require("trix")
require("@rails/actiontext")
require('./attachment_link')
